import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDSearchInput } from '@facet-wealth/design';
import FinancialInstitutionList
  from 'Components/ComponentLibrary/Organisms/LinkOrAddAccounts/InstitutionIcons/FinancialInstitutionList';
import InstitutionNotFound from 'Views/Page/Content/Templates/SelectInstitutionTemplate/InstitutionNotFound';
import useInstitutionSearch from 'Hooks/useInstitutionSearch';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs, testAttr } from 'Helpers/Testing';

const SearchableFinancialInstitutionList = ({
  resultsOverflow,
  startingInstitutions,

  searchPrompt,
  onSearch,

  onClickInstitution,

  onClickManualInstitutionAdd,
  manualInstitutionAddPrompt,
  manualInstitutionAddDescription,
}) => {
  const [institutions, setInstitutions] = useState(startingInstitutions);
  const [isSearching, setIsSearching] = useState(false);
  const [searchCount, setSearchCount] = useState(0);
  const { displayErrorMessage } = useSnackbarContext();

  const fetchInstitutions = React.useCallback(async (searchTerm) => {
    if (searchTerm === '') {
      setInstitutions(startingInstitutions);
      return;
    }
    setIsSearching(true);
    try {
      const resp = await onSearch(searchTerm);
      setIsSearching(false);
      setInstitutions(resp.resources().list());
      setSearchCount(prev => prev + 1);
    } catch (err) {
      setIsSearching(false);
      setSearchCount(prev => prev + 1);
      displayErrorMessage(err, 'Error searching');
    }
  }, [onSearch]);

  const {
    institutionName,
    handleChange,
  } = useInstitutionSearch(fetchInstitutions);


  const resultsFound = institutions.length > 0;
  return (
    <>
      <FDSearchInput
        {...dataAttrs('institution-search-input', {
          [testAttr.dataSearchCount]: searchCount,
        })}
        placeholder={searchPrompt}
        onChange={(e) => handleChange(e.target.value)}
        data-test="institution-search"
        fullWidth
        loading={isSearching}
        value={institutionName}
      />
      <FDBox paddingY={1} overflow={resultsOverflow}>
        {
          resultsFound ? (
            <FinancialInstitutionList
              onClick={onClickInstitution}
              institutions={institutions}
              baseURLAttr="baseUrl"
              iconAttr="icon"
              nameAttr="name"
            />
          ) : (
            <FDBox paddingY={5}>
              <InstitutionNotFound
                onClickManualInstitutionAdd={onClickManualInstitutionAdd}
                manualInstitutionAddPrompt={manualInstitutionAddPrompt}
                manualInstitutionAddDescription={manualInstitutionAddDescription}
              />
            </FDBox>
          )
        }
      </FDBox>
    </>
  );
};

SearchableFinancialInstitutionList.defaultProps = {
  resultsOverflow: 'visible',
};

SearchableFinancialInstitutionList.propTypes = {
  resultsOverflow: PropTypes.oneOf(['auto', 'visible']),

  startingInstitutions: PropTypes.array.isRequired,

  onSearch: PropTypes.func.isRequired,
  searchPrompt: PropTypes.string.isRequired,

  onClickInstitution: PropTypes.func.isRequired,

  onClickManualInstitutionAdd: PropTypes.func.isRequired,
  manualInstitutionAddPrompt: PropTypes.string,
  manualInstitutionAddDescription: PropTypes.string,
};

export default SearchableFinancialInstitutionList;
